import { render } from "./MaapSwitchPanel.vue?vue&type=template&id=44758366"
import script from "./MaapSwitchPanel.vue?vue&type=script&lang=js"
export * from "./MaapSwitchPanel.vue?vue&type=script&lang=js"

import "./MaapSwitchPanel.vue?vue&type=style&index=0&id=44758366&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__